//Todo: Replace with a db look-up
function generateSuppliers() {
  return ["BT-BROADBAND", "TALKTALK_LLU", "TALKTALK_NGA", "TALKTALK_OBIT"];
}

export default generateSuppliers();
